// Where a period's timer stands, from the match's active `dhbMatchTimers`
export const periodTimer = (dhbTimer, periodLength) => {
    const extraTime = dhbTimer.tickerAddSeconds ? dhbTimer.tickerAddSeconds : 0;
    const time = Date.now() - dhbTimer.tickerTimestamp;

    let timePlayed = dhbTimer.tickerStatus
        ? Math.floor(time / 1000) + extraTime + dhbTimer.tickerSeconds
        : dhbTimer.tickerSeconds;
    let timeLeft = periodLength - timePlayed;
    if (periodLength - timePlayed < 0) {
        timePlayed = periodLength;
        timeLeft = 0;
    }

    return {
        quarterStopped: !dhbTimer.tickerStatus,
        quarterStarted: dhbTimer.tickerStatus,
        timePlayed,
        timeLeft,
    };
};
